import * as consts from '../constants';
// import commonApi from '../api/mocks/mockCommonApi'
import commonApi from '../api/commonApi';

export function lockScreen() {
    return { type: consts.ACTONS.SCREEN_LOCK_REQUEST };
}

export function unlockScreen() {
    return { type: consts.ACTONS.SCREEN_UNLOCK_REQUEST };
}

export function loadConfigurationSuccess(configuration) {
    return { type: consts.ACTONS.LOAD_CONFIGURATION_SUCCESS, configuration };
}

export function loadConfiguration() {
    return function (dispatch, getState) {
        dispatch(lockScreen());
        return commonApi.loadConfiguration(getState().authenticationState.token).then(res => {
            dispatch(unlockScreen());
            dispatch(loadConfigurationSuccess(res));
        }).catch(error => {
            dispatch(unlockScreen());
            console.log(error);
        });
    };
}
